import { setFunnelModalConfig } from "../../funnel/FunnelModal";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { isPositiveFiniteNumber } from "../utils/payloadValidators";

export const PENDING_DONATION_CONFIRMATION_STORAGE_KEY =
  "pendingStripeDonationConfirmation";

/**
 * The donation-confirmation funnel survived the hosted-checkout decommission
 * because nothing in the embedded flow currently persists a pending value —
 * but the storage hook still has to drain leftover state from any user who
 * was mid-flow at deploy time, and the SPA-internal donation flow could
 * re-introduce a writer later. Once a release has rolled out fully, this
 * helper can be deleted alongside its storage key.
 */
export function restorePendingDonationConfirmation() {
  if (typeof window === "undefined") {
    return;
  }

  const pendingDonationConfirmation = window.sessionStorage.getItem(
    PENDING_DONATION_CONFIRMATION_STORAGE_KEY,
  );
  if (!pendingDonationConfirmation) {
    return;
  }

  window.sessionStorage.removeItem(PENDING_DONATION_CONFIRMATION_STORAGE_KEY);

  try {
    const context = JSON.parse(pendingDonationConfirmation);
    if (
      !context ||
      typeof context !== "object" ||
      !isPositiveFiniteNumber(context.donationArtistId)
    ) {
      return;
    }
    setFunnelModalConfig({
      type: FUNNEL_TYPES.donateConfirmation,
      context: { donationArtistId: context.donationArtistId },
    });
  } catch {
    // Ignore malformed persisted state.
  }
}

export function clearPendingDonationConfirmation() {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.removeItem(PENDING_DONATION_CONFIRMATION_STORAGE_KEY);
}
